module.exports = __webpack_public_path__ + "img/Fallback_Tap_Mine_8x1.47690a50.png";